import { Role } from "../../redux/api-model/organization/company";

export type NotificationCardData = {
  id: string;
  firstName?: string;
  lastName?: string;
  employeeId?: string | null;
  workContractId?: string | null;
  event: {
    type: string;
    absenceRequestDuration?: number;
    absenceRequestIcon?: string;
    endDate?: string | null;
    startDate?: string | null;
    absenceType?: string | null;
  };
};

export function getIsAbsenceType(
  type?: NotificationCardData["event"]["type"]
): boolean {
  return Boolean(type?.includes("ABSENCE"));
}

export function getEventLink(
  employeeRole: string,
  notificationData?: NotificationCardData
): string | null {
  const isAbsentType = getIsAbsenceType(notificationData?.event?.type);

  if (!isAbsentType || !notificationData) {
    return null;
  }

  if (employeeRole === Role.WORK_CONTRACT_ACCESS) {
    return `/app/contract/${notificationData.workContractId}/absences?absencesTab=1`;
  }

  return `/app/employees/${notificationData.employeeId}/contract/${notificationData.workContractId}?detailsTab=1&absencesTab=1`;
}
